import {Helmet} from "react-helmet";
import {useNavigate} from 'react-router-dom';
import {IconArrowBackUp} from "@tabler/icons-react";
import {ReactNode} from "react";

interface HeaderProps {
  title?: string;
  description?: string;
  extra?: ReactNode;
  hideBack?: boolean;
}

export default function Header(props: HeaderProps) {
  const navigate = useNavigate();
  return (
    <div className="px-4 py-1 flex justify-between items-center">
      <Helmet>
        <title>Pinnacle{props.title ? ` · ${props.title}` : ""}</title>
      </Helmet>
      <div>
          <div className="flex items-end">
              <div>
                  <span className="text-xl font-bold">Pinnacle</span>
                  <span className="pl-1 text-sm">
            {props.title ? `· ${props.title}` : ""}
          </span>
              </div>
              {location.pathname !== "/" && !props.hideBack && <button onClick={() => navigate(-1)} className="mb-0.5"><IconArrowBackUp size={20}/></button>}
          </div>
          {props.description && <div className="text-xs text-default-500">{props.description}</div>}
      </div>
      {props.extra}
    </div>
  );
}
